import request from '../utils/request';

export function summary() {
    return request.get('/summary');
}

export function reports(params) {
    return request.get('/reports2', {params});
}
